export default {
  gridList: {
    margin: 10,
  },
  button: {
    cursor: 'pointer',
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/styles.js